import { render, staticRenderFns } from "./MenuTopHeaderSale.vue?vue&type=template&id=72885dfb"
import script from "./MenuTopHeaderSale.vue?vue&type=script&lang=js"
export * from "./MenuTopHeaderSale.vue?vue&type=script&lang=js"
import style0 from "./MenuTopHeaderSale.vue?vue&type=style&index=0&id=72885dfb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports